/* eslint no-console: ["error", { allow: ["log", "warn", "error"] }] */

import RevampAPIServices from '@/services/revampApi';

const v1 = 'api/corporate_sales/v1';

// actions
const actions = {
  changeLanguage({ commit }, data) {
    commit('setLanguage', data);
  },
  fetchHomepageBanner({ commit }, data) {
    RevampAPIServices.get(`/${v1}/banner/${data.language}`)
      .then((response) => {
        const responseData = response.data;
        if (responseData.code === 200) {
          commit('setHomepageBanner', responseData.data);
        } else {
          commit('setHomepageBanner', {});
        }
      })
      .catch(() => {
        commit('setHomepageBanner', {});
      });
  },
  fetchFeaturepage({ commit }, data) {
    RevampAPIServices.post(`/${v1}/excellence/${data.language}/find-all-with-paging`, data)
      .then((response) => {
        const responseData = response.data;
        if (responseData.code === 200) {
          commit('setHomeFeature', responseData.data.results);
        } else {
          commit('setHomeFeature', {});
        }
      })
      .catch(() => {
        commit('setHomeFeature', {});
      });
  },
  fetchTestimonipage({ commit }, data) {
    RevampAPIServices.post(`/${v1}/testimonial/${data.language}/find-all-with-paging`, data)
      .then((response) => {
        const responseData = response.data;
        if (responseData.code === 200) {
          commit('setHomeTestimoni', responseData.data.results);
        } else {
          commit('setHomeTestimoni', {});
        }
      })
      .catch(() => {
        commit('setHomeTestimoni', {});
      });
  },
  fetchPartnerpage({ commit }, data) {
    RevampAPIServices.post(`/${v1}/partner/${data.language}/find-all-with-paging`, data)
      .then((response) => {
        const responseData = response.data;
        if (responseData.code === 200) {
          commit('setHomePartner', responseData.data.results);
        } else {
          commit('setHomePartner', {});
        }
      })
      .catch(() => {
        commit('setHomePartner', {});
      });
  },
};

export default actions;
